/**
 * Accessibility Fix for Combobox Role Violation
 * 
 * This script fixes the WCAG violation where elements with role="combobox" 
 * appear as descendants of elements with role="button".
 * 
 * The issue occurs when JavaScript dynamically adds role="button" to 
 * <summary> elements that contain inputs with role="combobox".
 * Since <summary> elements are semantically buttons by default, 
 * the explicit role="button" is redundant and creates nested interactive controls.
 */

document.addEventListener('DOMContentLoaded', function() {
  function fixSearchPopdown() {
    const popdownToggle = document.querySelector('[data-popdown-toggle]');
    if (popdownToggle && popdownToggle.getAttribute('role') === 'button') {
      popdownToggle.removeAttribute('role');
    }
  }

  fixSearchPopdown();
  
  new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && 
          mutation.attributeName === 'role' && 
          mutation.target.hasAttribute('data-popdown-toggle')) {
        fixSearchPopdown();
      }
    });
  })
  .observe(document.body, {
    attributes: true,
    attributeFilter: ['role'],
    subtree: true
  });
});
